import React from "react";
import { CardTileList } from "../../Card/CardTileList";
import { ChooseCardPopupProps } from "./types";

export const ChooseCardPopup = ({ deck, onSelect }: ChooseCardPopupProps) => {
  const deckWOLastTwo = deck.slice(0, -2);
  return (
    <div className="appear-from-opacity-40 absolute top-0 left-0 w-full h-full py-6 px-4 z-[100000000]">
      <div className="bg-black w-full h-full shadow-md overflow-auto">
        <h2 className="text-xl text-center mb-6 text-white pt-6">
          Choose Main Card
        </h2>
        <div className="text-sm text-white text-center mb-6 px-1">
          Be careful. This card will be lost if you lose. <br />
          All cards in your hand will be weaker than this card.
        </div>
        <CardTileList hexagens={deckWOLastTwo} onSelect={onSelect} />
      </div>
    </div>
  );
};
